import { createPlugin, PluginDef } from '@fullcalendar/core'

import { NamedTimeZoneImpl } from '@fullcalendar/core/internal';

import dayjs from 'dayjs';

import arraySupport from 'dayjs/plugin/arraySupport';
import customParse from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import toArray from 'dayjs/plugin/toArray';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(arraySupport);
dayjs.extend(toArray);
dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(quarterOfYear);
dayjs.extend(updateLocale);
dayjs.extend(customParse);


type IDateInputArray = [number?, number?, number?, number?, number?, number?, number?]
type IDateOutputArray = IDateOutputArrayStrict | number[]
type IDateOutputArrayStrict = [number, number, number, number, number, number, number]

class DayjsNamedTimeZone extends NamedTimeZoneImpl
{
	offsetForArray(a: IDateInputArray): number
	{
		return dayjs.tz(a, this.timeZoneName).utcOffset()
	}

	timestampToArray(ms: number)
	{
		return dayjs.tz(ms, this.timeZoneName).toArray() as IDateOutputArray
	}
}

const dayJsFullCalendarTimeZonePlugin = createPlugin({
	name: 'dayjs-fullcalendar-timezone',
	namedTimeZonedImpl: DayjsNamedTimeZone,
}) as PluginDef

export function isValidDayjs() {}

export { dayjs, dayJsFullCalendarTimeZonePlugin };
